import React, { FC } from 'react';
import { twMerge } from '@shared/utils/twMerge';

type LabelProps = {
  className?: string;
  children?: React.ReactNode;
};

export const Label: FC<LabelProps> = ({ className, children }) => {
  return (
    <div
      data-testid="Label"
      className={twMerge(
        'text-1216 leading-full bg-pastelBlue h-[20px] rounded-[32px] px-1 py-[2px] align-middle font-medium text-white',
        className
      )}
    >
      {children}
    </div>
  );
};
